// extracted by mini-css-extract-plugin
module.exports = {"amountOfDaysText":"PlanningsFormModal_amountOfDaysText__2WkO4"};